import React, { useEffect } from 'react'

interface ExternalRedirectProps {
  url: string
}

/**
 * Component để redirect đến external URL
 * Không thể dùng React Router Redirect cho external URLs
 */
const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ url }) => {
  useEffect(() => {
    window.location.href = url
  }, [url])

  return null
}

export default ExternalRedirect

